import axios from 'axios';
import type { AxiosResponse } from 'axios';

import { enableOtterIntegration, disableOtterIntegration } from '../api';

export async function connect(siteId: string): Promise<AxiosResponse> {
  return enableOtterIntegration(siteId, 'teams_webhook');
}

export async function disconnect(siteId: string): Promise<AxiosResponse> {
  return disableOtterIntegration(siteId, 'teams_webhook');
}

type Webhooks = string[];
type Questions = string[];

export type WidgetType = 'poll' | 'incoming_feedback' | 'recording_segment';

export interface FeedbackSettings {
  enabled: boolean;
  webhooks: Webhooks | null;
  connected: boolean;
  valid: boolean;
  dirty: boolean;
}

export interface SurveySettings extends FeedbackSettings {
  selectedQuestions: Questions;
}

export type Settings = FeedbackSettings | SurveySettings;

export interface FeedbackSettingsDto {
  enabled: boolean;
  webhooks: Webhooks | null;
}

export interface SurveySettingsDto extends FeedbackSettingsDto {
  settings: {
    questions: Questions;
  } | null;
}

export type SettingsDto = FeedbackSettingsDto | SurveySettingsDto;

export async function getFeedbackSettings(
  siteId: string,
  widgetId: string,
): Promise<FeedbackSettingsDto> {
  const response = await axios.get(
    `/api/integrations/sites/${siteId}/teams/hooks/feedback/${widgetId}`,
  );
  return response.data;
}

export async function saveFeedbackSettings(
  siteId: string,
  widgetId: string,
  settings: FeedbackSettingsDto,
): Promise<FeedbackSettingsDto> {
  return axios.put(`/api/integrations/sites/${siteId}/teams/hooks/feedback/${widgetId}`, settings);
}

export async function getSurveySettings(
  siteId: string,
  surveyId: string,
): Promise<SurveySettingsDto> {
  const response = await axios.get(
    `/api/integrations/sites/${siteId}/teams/hooks/survey/${surveyId}`,
  );
  return response.data;
}

export async function saveSurveySettings(
  siteId: string,
  surveyId: string,
  settings: SurveySettingsDto,
): Promise<AxiosResponse> {
  return axios.put(`/api/integrations/sites/${siteId}/teams/hooks/survey/${surveyId}`, settings);
}

export async function sendWebhookTestMessage(
  siteId: string,
  webhook: string,
): Promise<AxiosResponse> {
  return axios.put(`/api/integrations/sites/${siteId}/teams/hooks/test`, { webhook_url: webhook });
}
